module.exports = __webpack_public_path__ + "static/media/government.f8f51e95.svg";